var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStarFilled = function SvgStarFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "current",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5386 1.78067L27.1805 13.9297L27.3586 14.3134L27.7791 14.3594L41.319 15.8406L31.2699 24.7965L30.9455 25.0856L31.035 25.5108L33.7778 38.5475L21.9024 31.9586L21.5385 31.7567L21.1747 31.9586L9.29929 38.5475L12.0421 25.5108L12.1316 25.0856L11.8072 24.7965L1.75803 15.8406L15.298 14.3594L15.7185 14.3134L15.8966 13.9297L21.5386 1.78067Z",
    stroke: "current",
    strokeWidth: 1.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/starFilled.63c860a5.svg";
export { ForwardRef as ReactComponent };